<template>
	<div>				
		<div class="md-layout">
			<entity-card v-bind="{ schema, readEntity, deleteEntity, createEntity, updateEntity, submitErrorHandler: submitError }" :entity.sync="entity"></entity-card>				
		</div>
		<div>			
			<md-button :disabled="!entity.id || entity.id === 'novo'" @click.native.prevent="$router.push(`/empresa/${entity.id}/departamentos`)" class="md-accent">Departamentos</md-button>
			<md-button :disabled="!entity.id || entity.id === 'novo' || entity.eFilial === 1" @click.native.prevent="$router.push(`/empresa/${entity.id}/filiais`)" class="md-accent">Filiais</md-button>
		</div>
			
		<div class="md-layout" v-if="entity.id !== 'novo'">
			<md-card class="md-layout-item md-size-100">
				<md-card-header class="md-card-header-text md-card-header-accent">
					<div class="card-text">
						<h4 class="title">Testes liberados</h4>
					</div>
				</md-card-header>

				<md-card-content>
					<md-table :value="tests" class="paginated-table table-striped table-hover">
						<md-table-toolbar>
							<div class="md-layout">
								<div class="md-layout-item" style="text-align: right">
									<md-button class="md-accent" style="margin: 5px" @click="$router.push(`/empresa/${entity.id}/teste/novo`)">Adicionar</md-button>
								</div>
							</div>
						</md-table-toolbar>

						<md-table-row slot="md-table-row" style="cursor: pointer">
							<md-table-head>Teste</md-table-head>
						</md-table-row>

						<md-table-row v-for="(field, fieldIndex) in tests" :key="fieldIndex" :md-sort-by="field.name" slot="md-table-row" @click="$router.push(`/empresa/${entity.id}/teste/${field.id}`)" style="cursor: pointer">
							<md-table-cell :md-label="field.articleName">{{field.articleName}}</md-table-cell>
						</md-table-row>
					</md-table>
				</md-card-content>
			</md-card>
		</div>		
	</div>
</template>

<script>
	import Company from "@/models/company.model.vue"
	import EntityCard from "@/components/Espresso/EntityCard.vue"
	import EspressoAux from "@/components/Espresso/EspressoAux.vue";
	import CompanyArticle from "@/models/companyArticle.model.vue";
	import { Tabs, Modal } from '@/components';
	import PaginatedSearch from "@/components/Espresso/BackendPaginatedSearch.vue";

	export default {
		components: {
			EntityCard,
			PaginatedSearch,
			Tabs,
			Modal,
		},
		data() {
			return {
				entity: {
					id: this.$route.params.id,
				},
				tabs: ['Empresas'],
				schema: Company.getSchema(),
				//schemaCompanyArticle: CompanyArticle.getSchema(),
				tests: []
			}
		},
		methods: {
			async createEntity(entity) {
				this.entity = await Company.create(entity);
				this.$router.replace(`/empresa/${this.entity.id}`);
				return this.entity;
			},
			async readEntity(entityId) {
				return Company.getInfo(entityId);
			},
			async updateEntity(entity) {
				const dataToUpdate = Object.assign({}, entity);
				return Company.updateInfo(dataToUpdate);				
			},
			async deleteEntity(entityId) {
				await Company.remove(entityId);
				this.$router.push(`/empresas`);
			},
			async submitError(error) {
				console.log(error);
				if(error.message.indexOf("ERR_API_COMPANY_CNPJ_EXISTS_") != -1) {
					EspressoAux.showFailModal(error.message.replace("ERR_API_COMPANY_CNPJ_EXISTS_",""));
				}
			},
			async syncEntity() {
				//console.log('sync sub-entities');
				const { value } = await EspressoAux.showLoadingModal(Company.syncSubCompanies(this.entity.id), "Processando...", "", "Não foi possível atualizar a empresa.", this.syncEntityErrorHandler);
				//console.log(value);
				if (value) {
					this.getTests();
				}
				return value;
			},
			async syncEntityErrorHandler(err) {
				//console.log('erro handler', err.toString());
				if (err && err.toString().indexOf("ERR_COMPANY_NOT_FOUND_API") > -1) {
					EspressoAux.showFailModal("Empresa não encontrada na API.");
				} else if (err && err.toString().indexOf("ERR_COMPANY_NOT_SAPID")) {
					EspressoAux.showFailModal("Empresa sem IDSAP.");
				} else {
					EspressoAux.showFailModal("Não foi possível atualizar a empresa.");
				}
			},

			// async searchEntitiesArticle(paginationParameters) {
			// 	const parameters = {
			// 		...paginationParameters,
			// 		companyId: this.entity.id,
			// 	}

			// 	return CompanyArticle.search(parameters)
			// },
			// async openEntityArticle(entity) {
			// 	this.$router.replace(`/empresa/${this.entity.id}/teste/${entity.id}`);
			// },
			// async createEntityArticle() {
			// 	this.$router.push(`/empresa/${this.entity.id}/teste/novo`);
			// },

			async getTests() {
				const response = await CompanyArticle.search({ companyId: this.entity.id });
				this.tests = response.results;
				
			}
		},
		mounted() {
			// if ((this.entity.id) && (this.entity.id !== "novo")) {
			// 	this.tabs.push("Testes");				
			// }
		},
		created() {
			if (this.entity.id !== "novo") {
				this.getTests();
			}
		}
	};
</script>

<style>
.tab-pane-1,
.tab-pane-2 {
  width: 100% !important;
}
</style>